<template>
    <div
        class="header__profile"
        :class="{ 'header__profile-admin ::-webkit-scrollbar': isAdmin }"
    >
        <div
            class="header__profile-info"
            :class="{ 'header__profile-info--subscription': subscription }"
        >
            <div class="header__profile-text">{{ user.name }}</div>

            <div class="header__profile-text">{{ user.email }}</div>
        </div>
        <div v-if="user.role.title === 'user'">
            <a
            v-if="!subscription"
            class="header__profile-link header__profile-link-subscription"
            href="/page/subscription-managment"
            >
                {{ $lang("MobileMenu.subscribe.menu") }}
            </a>

            <a
                v-else
                class="header__profile-link header__profile-link-subscription header__profile-link-subscription--active"
                href="/page/subscription-managment"
            >
                <img src="../../../img/icons/subscription_success.svg" alt="" />
                <span v-html="subscriptionName" />
            </a>
        </div>

        <router-link
            class="header__profile-link header__profile-link--border"
            :to="{ name: profileRouteName }"
        >
            {{ $lang("miniProfile.myData") }}
        </router-link>

        <div v-if="headerPagesHtml" v-html="headerPagesHtml" />

        <a
            v-else
            class="header__profile-link"
            :href="memoriesPageLink"
            v-html="$lang('MiniProfile.myProfile')"
        ></a>

        <!--User sections-->
        <div v-if="!isAdmin">
            <div v-for="page in pages">
                <a
                    v-if="page.roles.includes(userRoleName)"
                    :href="userSectionPrefix + page.href"
                    :dusk="page.dusk"
                    class="nav__auth-link nav__auth-link--menu"
                >
                    {{ page.name }}
                    <div
                        v-if="page.hasNameplate"
                        class="nav__auth__link-nameplate"
                    >
                        <img
                            class="nameplate-icon"
                            src="../../../img/icons/aiBot.svg"
                            alt="AI"
                        />
                        {{ $lang("userMenu.aiBot") }}
                    </div>
                </a>
            </div>
        </div>
        <!--admin sections-->
        <div v-else>
            <admin-sections />
        </div>
        <!--Logout button-->
        <header-logout-button class="nav__auth-btn"></header-logout-button>
    </div>
</template>

<script>
import HeaderLogoutButton from "./HeaderLogoutButton";
import HeaderDesktopButton from "./HeaderDesktopButton";
import { mapState } from "vuex";
import Vue from "vue";
import AdminSections from "./AdminSections.vue";

export default {
    name: "HeaderProfile",
    components: {
        AdminSections,
        HeaderDesktopButton,
        HeaderLogoutButton
    },
    props: ["isAdmin"],
    data() {
        return {
            user: window.laravel.user,
            prefix: window.laravel.prefix,
            isPartner: window.laravel.isPartner,
            subscription: window.laravel.subscription,
            subscriptionName: Vue.prototype.$lang(window.laravel.subscription?.subscription_type.name),
            pages: [
                {
                    name: Vue.prototype.$lang("app.menu.desktop"),
                    href: "/",
                    roles: ["admin"],
                    dusk: "link-home"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title6"),
                    href: "/pages",
                    roles: ["admin", "partner", "master"],
                    dusk: "link-pages",
                    hasNameplate: true
                },
                {
                    name: Vue.prototype.$lang("userMenu.title7"),
                    href: "/pages/related",
                    roles: ["admin", "partner", "master"],
                    dusk: "link-burial"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title3"),
                    href: "/partners",
                    roles: ["admin"],
                    dusk: "link-partners"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title4"),
                    href: "/masters",
                    roles: ["admin", "partner"],
                    dusk: "link-masters"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title5"),
                    href: "/responsibles",
                    roles: ["admin", "partner", "master"],
                    dusk: "link-responsibles"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title9"),
                    href: "/locations",
                    roles: ["admin"],
                    dusk: "link-locations"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title19"),
                    href: "/places",
                    roles: ["admin", "partner", "master"],
                    dusk: "link-places"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title1"),
                    href: "/pages",
                    roles: ["user"],
                    dusk: "link-pages",
                    hasNameplate: true
                },
                {
                    name: Vue.prototype.$lang("userMenu.family-tree"),
                    href: "/tree",
                    roles: ["user"],
                    dusk: "link-tree"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title2"),
                    href: "/purchases",
                    roles: ["user"],
                    dusk: "link-pay"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title8"),
                    href: "/news",
                    roles: ["admin"],
                    dusk: "link-news"
                },
                {
                    name: Vue.prototype.$lang("app.menu.articles"),
                    href: "/articles",
                    roles: ["admin"],
                    dusk: "link-articles"
                },

                {
                    name: Vue.prototype.$lang("userMenu.title20"),
                    href: "/prices",
                    roles: ["admin"],
                    dusk: "link-prices"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title21"),
                    href: "/langs",
                    roles: ["admin"],
                    dusk: "link-langs"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title24"),
                    href: "/promo-codes",
                    roles: ["admin"],
                    dusk: "link-promo-codes"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title22"),
                    href: "/onboarding",
                    roles: ["master"],
                    dusk: "link-onboarding"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title18"),
                    href: "/banner",
                    roles: ["partner"],
                    dusk: "link-banner"
                },
                {
                    name: Vue.prototype.$lang("userMenu.title23"),
                    href: "/statistics",
                    roles: ["partner"],
                    dusk: "link-partner-statistics"
                }
            ]
        };
    },
    computed: {
        ...mapState("header", ["headerPagesHtml"]),
        memoriesPageLink() {
            return this.user.profile
                ? window.laravel.prefix + "/memories/" + this.user.profile.slug
                : window.laravel.prefix + "/memories/edit";
        },
        profileRouteName() {
            return this.isPartner ? "profile-partner" : "profile-user";
        },
        userRoleName() {
            return this.user ? this.user.roles[0].title : null;
        },
        userSectionPrefix() {
            return this.prefix + "/cabinet";
        }
    }
};
</script>

<style scoped>
::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
}
</style>
